/**
 * @generated SignedSource<<8c849afb5d996c0da8ce13a1002da915>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SearchBarRepo$data = {
  readonly isInOrganization: boolean;
  readonly viewerCanSeeIssueFields: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBarActionsRepositoryFragment">;
  readonly " $fragmentType": "SearchBarRepo";
};
export type SearchBarRepo$key = {
  readonly " $data"?: SearchBarRepo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBarRepo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBarRepo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInOrganization",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SearchBarActionsRepositoryFragment"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanSeeIssueFields",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "fb9a1c5ba299c39422336b8e4fd4d059";

export default node;
